import React from "react";
import { MetricRow } from "./SnapshotMetricCard";

function CrewStatusBadge({ breakActive }) {
  return (
    <div
      className="kpi-status-badge"
      style={{
        background: breakActive
          ? "rgba(239,68,68,0.12)"
          : "rgba(34,197,94,0.12)",
        border: breakActive
          ? "1px solid rgba(239,68,68,0.35)"
          : "1px solid rgba(34,197,94,0.35)",
        flexShrink: 0,
      }}
    >
      <span
        className="kpi-status-dot"
        style={{
          backgroundColor: breakActive ? "#ef4444" : "#22c55e",
        }}
      />
      <span
        className="kpi-status-text"
        style={{
          color: breakActive ? "#ef4444" : "#22c55e",
        }}
      >
        {breakActive ? "On Break" : "Working"}
      </span>
    </div>
  );
}

/**
 * Active crew member list — same rows previously shown in the KPI Dashboard
 * ACTIVE CREW section. Selecting a row opens the employee session detail overlay.
 */
export function ActiveCrewList({ crewList, onSelectCrew, emptyMessage }) {
  if (crewList.length === 0) {
    return (
      <p className="kpi-empty kpi-empty--pad">
        {emptyMessage || "No active employees."}
      </p>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      {crewList.map((crew) => (
        <MetricRow
          key={`${crew.supabase_user_id}-${crew.session_start}`}
          label={crew.employee_name || "Unknown Employee"}
          subtitle={crew.project_name}
          valueNode={<CrewStatusBadge breakActive={crew.break_active} />}
          onClick={() => onSelectCrew(crew)}
        />
      ))}
    </div>
  );
}
